"use client";

import { Camera, Loader2 } from "lucide-react";

interface PropertyPhotosButtonProps {
	hasPhotos: boolean;
	onClick: () => void;
	isLoading?: boolean;
}

export default function PropertyPhotosButton({
	hasPhotos,
	onClick,
	isLoading = false,
}: PropertyPhotosButtonProps) {
	const ariaLabel = hasPhotos ? "View photos" : "Request photos";

	return (
		<button
			type="button"
			onClick={(e) => {
				e.stopPropagation();
				onClick();
			}}
			disabled={isLoading}
			aria-label={ariaLabel}
			title={undefined}
			aria-busy={isLoading}
			className="inline-flex items-center justify-center rounded-lg border border-gray-300 bg-white px-2 py-1.5 text-xs font-medium text-[#12301b] hover:border-[#A7FF5E] hover:bg-[#A7FF5E]/10 transition-colors disabled:opacity-70 disabled:pointer-events-none"
		>
			{isLoading ? (
				<Loader2 className="w-4 h-4 animate-spin" aria-hidden />
			) : (
				<Camera className="w-4 h-4" aria-hidden />
			)}
		</button>
	);
}
